export interface SessionUser {
  id: string;
  name: string;
  email: string;
  role: 'admin' | 'streamer';
  profileImageKey: string | null;
}

const tokenKey = 'verena-livetask-token';
const userKey = 'verena-livetask-user';

export function getToken(): string | null { return localStorage.getItem(tokenKey); }
export function getUser(): SessionUser | null {
  const value = localStorage.getItem(userKey);
  if (!value) return null;
  try { return JSON.parse(value) as SessionUser; } catch { return null; }
}
export function saveSession(token: string, user: SessionUser): void {
  localStorage.setItem(tokenKey, token);
  localStorage.setItem(userKey, JSON.stringify(user));
}
export function clearSession(): void {
  localStorage.removeItem(tokenKey);
  localStorage.removeItem(userKey);
}
